import { Outlet } from "react-router-dom";
import AppNavBar from "../navbar/AppNavBar";
import { useAuth } from "../auth/AuthProvider";

export default function HomeLayout() {
  const { userToken } = useAuth();

  return (
    <div>
      <AppNavBar key={userToken} />
      <Outlet />
    </div>
  );
}
